module.exports = __webpack_public_path__ + "static/media/ni.2b983496.svg";